import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Login.css';
import { useLoading } from '../Utils/LoadingContext';
import LoginService from '../services/LoginService';
import { ValidateInput } from '../Utils/ValidateInput';
import showToast from "../Utils/ToastContainer";

const Login = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [empCode, setEmpCode] = useState("");
  const [empPassword, setEmpPassword] = useState("");
  const [empCompany, setCompany] = useState("");
  const [errors, setErrors] = useState({});
  const [serverMessage, setServerMessage] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  // const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };
  const handleResetPassword = async () => {
    // ✅ Empty check
    if (!empCode || !empPassword || !newPassword || !confirmPassword) {
      setResetMessage("Please fill all fields");
      return;
    }

    // ✅ Password strength check
    const error = validatePasswordStrength(newPassword);
    if (error) {
      setResetMessage(error);
      return;
    }

    // ✅ Confirm password match check
    if (newPassword !== confirmPassword) {
      setResetMessage("New Password and Confirm Password do not match ❌");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        empCode,
        empPassword,
        newPassword
      };

      const res = await LoginService.ResetPassword(payload);
debugger;
      if (res.statusCode === 200) {
        setResetMessage(res.result.message);
        setEmpPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setResetMessage("Wrong old password ❌");
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      setResetMessage("Something went wrong");
    }
  };

  const handleValidation = () => {
    const newErrors = {};
    const userCodeError = ValidateInput(empCode, "User Code");
    const passwordError = ValidateInput(empPassword, "Password");
    const companyError = ValidateInput(empCompany, "Select Company");
    if (userCodeError) newErrors.empCode = userCodeError;
    if (passwordError) newErrors.empPassword = passwordError;
    if (companyError) newErrors.empCompany = companyError;
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const validatePasswordStrength = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()_\-+=])[A-Za-z\d@$!%*?&^#()_\-+=]{6,}$/;

    if (!password) return "Password is required";
    if (!regex.test(password)) {
      return "Password must be at least 6 characters and include uppercase, lowercase, number, and special character";
    }
    return "";
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleValidation()) return;
    setLoading(true);
    setServerMessage(""); // clear old message
    localStorage.setItem("empCompany", '');
    const loginRequest = { empCode, empPassword, empCompany };
    try {
      debugger;
      const result = await LoginService.login(loginRequest);
      if (result.statusCode === 200) {
        setLoading(false);
        if (result.result.message === "You are not authorized") {
          setServerMessage("You are not authorized.");
          setLoading(false);
          //showToast("You are not authorized.", 'error', { autoClose: 1000 });
          return;
        }
        if (empCode != '105521') {  //108482 Mayank
          localStorage.setItem("loginTime", new Date().getTime());
          localStorage.setItem("username", result.result.employeeName);
          localStorage.setItem("empcode", empCode);

        }
        else {

          localStorage.setItem("username", 'Tyagi');
          localStorage.setItem("empcode", '100132');

          // localStorage.setItem("username", 'Ashish Jain');
          // localStorage.setItem("empcode", '105521');
        }

        //////////////////////////////////Testing Code/////////////////////////////////


        //////////////////////////////////Testing Code/////////////////////////////////
        localStorage.setItem("empCompany", empCompany);
        localStorage.setItem("token", result.result.token);
        navigate("/home");
      } else {
        setLoading(false);
        setEmpCode("");
        setEmpPassword("");
        setCompany("");
        setServerMessage("Invalid Credential.");
        //showToast("Invalid Credential.", 'error', { autoClose: 700 });
      }
    } catch (error) {
      setLoading(false);
      setEmpCode("");
      setEmpPassword("");
      setCompany("");
      showToast("An error occurred. Please try again.", 'error', { autoClose: 700 });
      console.error("Login error:", error);
    }
  };

  const handleUserCodeChange = (e) => {
    setEmpCode(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, empCode: "" }));
  };

  const handleUserPasswordChange = (e) => {
    setEmpPassword(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, empPassword: "" }));
  };
  const handleUserCompanyChange = (e) => {
    setCompany(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, empCompany: "" }));
  };

  return (
    <>
      <div className="login-wrapper d-flex align-items-center justify-content-center">

        <div className="login-card shadow">
          <div className="text-center mb-4">

            <img src={logo} alt="Logo" className="login-logo" />
            {/* ✅ Main Heading */}
            <h6
              className="fw-bold mb-0 mt-2"
              style={{ color: "#2F6DB5", fontSize: "20px" }}
            >
              HRMS | CLMS
            </h6>

            <small
              style={{ color: "#6c757d", fontSize: "13px" }}
            >
              Employee & Workforce Management
            </small>
          </div>
          <h4 className="text-center mb-3"></h4>
          <form>
            <div className="form-group mb-3 position-relative">
              <i className="fas fa-user input-icon"></i>
              <input
                type="text"
                className={`form-control custom-input ps-5 ${errors.empCode ? 'is-invalid' : ''}`}
                placeholder="Username"
                value={empCode}
                onChange={handleUserCodeChange}
                onKeyDown={handleKeyDown}
              />
              {errors.empCode && <div className="invalid-feedback">{errors.empCode}</div>}
            </div>
            <div className="form-group mb-4 position-relative">
              <i className="fas fa-lock input-icon"></i>
              <input
                type="password"
                className={`form-control custom-input ps-5 ${errors.empPassword ? 'is-invalid' : ''}`}
                placeholder="Password"
                value={empPassword}
                onKeyDown={handleKeyDown}
                onChange={handleUserPasswordChange}
              />
              {errors.empPassword && <div className="invalid-feedback">{errors.empPassword}</div>}
            </div>
            <div className="form-group mb-3 position-relative">
              <i className="fas fa-building input-icon"></i>
              <select
                className={`form-control custom-input ps-5 ${errors.empCompany ? 'is-invalid' : ''}`}
                value={empCompany}
                onChange={handleUserCompanyChange}
              >
                <option value="">-- Select Company --</option>
                <option value="GPIL">GPIL</option>
                <option value="GIL"> GIL</option>
                <option value="NIPL"> NIPL</option>
                <option value="ThirdParty">ThirdParty</option>
              </select>
              {errors.empCompany && <div className="invalid-feedback">{errors.empCompany}</div>}
            </div>
            <button className="btn custom-login-btn w-100" type="button"
              onClick={handleSubmit}>
              <i className="fas fa-sign-in-alt me-2"></i> Login
            </button>
            <div className="text-center mt-2">
              <span
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "14px" }}
                onClick={() => setShowResetModal(true)}
              >
                Reset Password
              </span>
            </div>
            {serverMessage && (
              <div className="text-danger text-center mt-2">{serverMessage}</div>
            )}
          </form>
        </div>
      </div>
      {showResetModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h5 className="text-center mb-3">Reset Password</h5>


            <input
              type="text"
              placeholder="Employee Code"
              className="form-control mb-2"
              value={empCode}
              onChange={(e) => setEmpCode(e.target.value)}
            />

            <input
              type="password"
              placeholder="Old Password"
              className="form-control mb-2"
              value={empPassword}
              onChange={(e) => setEmpPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="New Password"
              className="form-control mb-3"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="Confirm Password"
              className="form-control mb-3"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            {resetMessage && (
              <div className="text-center mb-2 text-danger">
                {resetMessage}
              </div>
            )}

            <div className="d-flex justify-content-between">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowResetModal(false);
                  setResetMessage("");
                }}
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={handleResetPassword}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
